import { Controller } from "@hotwired/stimulus"

// Âncora in-page: rola até o alvo sem Turbo, sem submit e sem recarregar.
// <a href="#secao" data-controller="scroll-to" data-action="click->scroll-to#go">
export default class extends Controller {
  go(event) {
    event.preventDefault()
    event.stopPropagation()

    const id = this.element.hash?.replace("#", "")
    const target = id && document.getElementById(id)
    if (!target) return

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" })
  }
}
